export const AUTH_TOKEN = 'formclue_admin_auth_token';
export const AUTH_USER = 'formclue_admin_user';
export const TURNSTILE_SITE_KEY = "0x4AAAAAAB6ckQ807Dv9Sdhv";
